import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { GetProductCatFeatureAtom } from "../../store/productCategoryFeatureAtom";

export default function ProductFeatureScroll() {
  const { id } = useParams();
  const navigate = useNavigate();

  const productAtom = GetProductCatFeatureAtom();
  const [features, setFeatures] = useState([]);

  useEffect(() => {
    if (productAtom?.product_feature_info?.length) {
      setFeatures(
        productAtom.product_feature_info.map((item) => ({
          ...item,
          checked: false,
        }))
      );
    }
  }, [productAtom?.product_feature_info]);

  const handleSelect = (productId) => {
    navigate(`../details/${productId}`);
  };

  const toggleCheckbox = (e, index) => {
    e.stopPropagation(); // prevent row click when checking box
    const updated = [...features];
    updated[index].checked = e.target.checked;
    setFeatures(updated);
    // props.onSelection?.(updated); // if you still need bulk selection callback
  };

  const statusBadge = (statusName) => {
    const styles = {
      Active: "bg-emerald-100 text-emerald-800 border-emerald-200",
      Inactive: "bg-rose-100 text-rose-800 border-rose-200",
      "Pending for Approval": "bg-amber-100 text-amber-800 border-amber-200",
      Confirmed: "bg-indigo-100 text-indigo-800 border-indigo-200",
      Rejected: "bg-red-100 text-red-800 border-red-200",
      Fulfilled: "bg-blue-100 text-blue-800 border-blue-200",
      "Partially Billed": "bg-purple-100 text-purple-800 border-purple-200",
    };

    return (
      <span
        className={`inline-flex px-2.5 py-1 rounded-full text-xs font-medium border ${
          styles[statusName] || "bg-gray-100 text-gray-700 border-gray-200"
        }`}
      >
        {statusName || "—"}
      </span>
    );
  };

  return (
    <div className="h-full bg-white border-r flex flex-col">
      {/* Fixed Header */}
      <div className="px-5 py-4 border-b bg-gray-50">
        <h3 className="text-sm font-semibold text-gray-700 tracking-tight">
          Product Features
          <span className="ml-1.5 text-gray-500 font-normal">
            ({features.length})
          </span>
        </h3>
      </div>

      {/* Scrollable List */}
      <div className="flex-1 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-50 hover:scrollbar-thumb-gray-400 transition-colors">
        {features.length === 0 ? (
          <div className="h-full flex flex-col items-center justify-center text-gray-500 text-sm px-6 text-center py-10">
            <p className="font-medium">No features found</p>
            <p className="mt-1 text-gray-400">Create a new feature to get started</p>
          </div>
        ) : (
          <div className="divide-y divide-gray-100">
            {features.map((feature, index) => {
              const isActive = Number(id) === Number(feature?.Product_Id);

              return (
                <div
                  key={feature.Product_Id || index}
                  onClick={() => handleSelect(feature.Product_Id)}
                  className={`
                    group px-5 py-3.5 cursor-pointer transition-all duration-150
                    hover:bg-indigo-50/60
                    ${isActive 
                      ? "bg-indigo-50/80 border-l-4 border-l-indigo-500 font-medium" 
                      : "hover:border-l-4 hover:border-l-indigo-300/50"}
                  `}
                >
                  <div className="flex items-start justify-between gap-3">
                    {/* Checkbox – optional / can be re-enabled for bulk actions */}
                    {/* <div className="flex-shrink-0 pt-0.5">
                      <input
                        type="checkbox"
                        checked={feature.checked}
                        onChange={(e) => toggleCheckbox(e, index)}
                        onClick={(e) => e.stopPropagation()}
                        className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                      />
                    </div> */}

                    {/* Main content */}
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-medium text-gray-900 line-clamp-2">
                        {feature?.Product_Name || feature?.Feature_Name || "Unnamed Feature"}
                      </p>

                      <div className="mt-1.5 flex items-center gap-3 text-xs">
                        <span className="text-gray-600">
                          Ref: <span className="font-mono">{feature?.Product_Id || "—"}</span>
                        </span>

                        <div className="ml-auto">
                          {statusBadge(feature?.Status_Name)}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* Footer count */}
      {features.length > 0 && (
        <div className="px-5 py-2.5 bg-gray-50 border-t text-xs text-gray-500 flex justify-between items-center">
          <span>
            {features.length} {features.length === 1 ? "feature" : "features"}
          </span>
          <span className="text-gray-400">Click to view details</span>
        </div>
      )}
    </div>
  );
}